import { type SxProps } from '@mui/material';
import { isNullOrUndefined } from '@vy/utils';
import React from 'react';
import { VyAccordion } from '../../../../components/new-design/data-display/VyAccordion/VyAccordion';
import { useToggle } from '../../../../hooks/use-toggle';

type ContractSummaryDetailSectionProps = {
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  count?: number;
  defaultExpanded?: boolean;
  sx?: SxProps;
};

export const ContractExpandableSection: React.FC<ContractSummaryDetailSectionProps> = ({
  title,
  icon,
  children,
  count,
  defaultExpanded = true,
  sx,
}) => {
  const [expanded, toggleExpanded] = useToggle(defaultExpanded);
  const label = isNullOrUndefined(count) ? title : `${title} (${count})`;

  return (
    <VyAccordion icon={icon} title={label} expanded={expanded} onChange={() => toggleExpanded()} sx={sx}>
      {children}
    </VyAccordion>
  );
};
